import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=0aafc138&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=0aafc138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafc138",
  null
  
)

export default component.exports